import { render, staticRenderFns } from "./HotSaleList.vue?vue&type=template&id=cb206bc0&scoped=true"
import script from "./HotSaleList.vue?vue&type=script&lang=js"
export * from "./HotSaleList.vue?vue&type=script&lang=js"
import style0 from "./HotSaleList.vue?vue&type=style&index=0&id=cb206bc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb206bc0",
  null
  
)

export default component.exports